import React from "react";
import { format } from "@backpacker/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import Modal from "@ui-kit/modal";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";

export interface IProps {
  locale: Locale;
  timezone: Timezone;
  project: Project;
  onCancel: () => void;
  onValidate: () => void;
}

const BlockedProjectModal = ({
  locale,
  project,
  timezone,
  onCancel,
  onValidate,
}: IProps) => (
  <Modal
    locale={locale}
    title={tr(locale, "PROJECT_HOME::SUBSCRIPTION_ENDED_TITLE", {
      date: format(project.stop, timezone),
    })}
    description={tr(locale, "PROJECT_HOME::SUBSCRIPTION_ENDED", {
      name: project.label,
    })}
    drawing="hourglass-arrow-cross"
    help={tr(locale, "PROJECT_HOME::MORE_HELP_CENTER", {
      url: tr(locale, "HELP.URLS::DASHBOARD_HOME"),
    })}
    cancelLabel={tr(locale, "MODAL::CLOSE_WINDOW")}
    onCancel={onCancel}
    onValidate={onValidate}
    validateLabel={tr(locale, "PROJECT_HOME::CONTACT_PROJECT_MANAGER")}
  />
);

export default BlockedProjectModal;
